import React from 'react';

import {translations} from 'presentation/translations-new';

import {StyledAvailability, StyledAvailabilityTitle, StyledLocationList} from './styles';

const {availableTitle, availableLocations} = translations['pt-br'].privateFlow.services.saludia;

export function SaludiaAvailability() {
	return (
		<StyledAvailability>
			<StyledAvailabilityTitle>{availableTitle}</StyledAvailabilityTitle>
			<StyledLocationList>
				{availableLocations.map(location => (
					<li key={location}>{location}</li>
				))}
			</StyledLocationList>
		</StyledAvailability>
	);
}
